import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
    selector: 'app-blank',
    templateUrl: './blank.component.html',
    styleUrls: [],
    standalone: true,
    // Must stay Eager until every routed page is OnPush: this shell wraps the
    // router-outlet, and an OnPush shell blocks CD traversal into Eager pages.
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule, MatSidenavModule]
})
export class AppBlankComponent { }
